import { render, staticRenderFns } from "./BusinessInformationUploadDocsList.vue?vue&type=template&id=215ca312"
import script from "./BusinessInformationUploadDocsList.vue?vue&type=script&lang=js"
export * from "./BusinessInformationUploadDocsList.vue?vue&type=script&lang=js"
import style0 from "./BusinessInformationUploadDocsList.vue?vue&type=style&index=0&id=215ca312&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports